import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { EpEventService, EpButtonStyle, EpButtonType, EpDialogService } from '@epicor/kinetic';
import { ErrorStatus } from 'ep-bt-controls';
import {
  CheckoutResults, CheckoutParametersTransactionType,
  CheckoutParametersSaleType, EmailTemplate, Shift4SettingsI4GoCardholderNamePrompt,
  Shift4SettingsI4GoStreetAddressPrompt,
  Shift4SettingsI4GoPostalCodePrompt, BisTrackSettingsPaymentProvider
} from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFaQuickOrderSummaryService } from '../../services/epbt-fa-quick-order-summary.service';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaQuickOrderEmailComponent } from '../epbt-fa-quick-order-email/epbt-fa-quick-order-email.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-order-summary',
  templateUrl: './epbt-fa-quick-order-summary.component.html',
  styleUrls: ['./epbt-fa-quick-order-summary.component.scss']
})
export class EpbtFaQuickOrderSummaryComponent implements OnInit {

  @ViewChild(EpbtFaQuickOrderEmailComponent, {static: false}) epbtFaQuickOrderEmailComponent: EpbtFaQuickOrderEmailComponent;

  EpButtonStyle = EpButtonStyle;
  EpButtonType = EpButtonType;
  // currency: string;
  @Input() isQuickOrder = false;
  i4Go1 = false;
  i4Go2 = false;

  i4GoErrorCodeLiteralText = '';
  i4GoErrorView = false;
  emailButtonForOrders = false;

  constructor(public quickOrderSummaryService: EpbtFaQuickOrderSummaryService,
    public quickOrderService: EpbtFaQuickOrderService,
    private faService: EpbtFieldAgentService, private router: Router) { }

  ngOnInit() {
    this.loadSummary();
    // if (this.faService.bisTrackSetting) {
    //   this.currency = this.faService.currency;
    // }
    // else {
    //   this.faService.getBisTrackSetting((bistrackSettings: any) => {
    //     this.currency = bistrackSettings.baseCurrency.symbol;
    //   });
    // }
    this.quickOrderSummaryService.isQuickOrder = this.isQuickOrder;
  }

  completeQuickOrder() {
    const dialog = EpDialogService.progress({ message: 'Please wait...', description: '' });
    this.quickOrderSummaryService.generateWebTrackOrder((result: CheckoutResults) => {
      dialog.close();
      if (result && result.success) {
        this.faService.displayToastMessage('Success', 'Reference Number: ' + result.bisTrackReference, ErrorStatus.Success);
        this.router.navigate(['/home']);
      } else {
        this.faService.displayToastMessage('Error', 'Something went worng', ErrorStatus.Error);
      }
    });
  }

  payNowClick(type: string) {
    if (this.quickOrderSummaryService.bisTrackSettings.paymentProvider == BisTrackSettingsPaymentProvider.Shift4) {
      if (type == 'PayNow' && this.quickOrderService.showShift4EnterAVSView &&
        (this.quickOrderService.cardHolderNameDiv || this.quickOrderService.streetAddressDiv || this.quickOrderService.postalCodeDiv)) {
        this.quickOrderSummaryService.cardHolderName = '';
        this.quickOrderSummaryService.streetAddress = '';
        this.quickOrderSummaryService.postalCode = '';
        this.quickOrderSummaryService.setViewsVisible(false, false, true, false, false, false, false);
      } else {
        this.quickOrderService.wizardView = false;
        if (this.quickOrderSummaryService.i4goTrueTokenParameters) {
          localStorage.setItem('i4GoParameters', JSON.stringify(this.quickOrderSummaryService.i4goTrueTokenParameters));
          this.quickOrderSummaryService.setViewsVisible(false, false, false, true, false, false, false);
          this.loadPaymentView();
        } else {
          this.quickOrderSummaryService.geti4goTrueTokenParameters((result: any) => {
            localStorage.setItem('i4GoParameters', JSON.stringify(result));
            this.quickOrderSummaryService.setViewsVisible(false, false, false, true, false, false, false);
            this.loadPaymentView();
          });
        }
      }
    } else if (this.quickOrderSummaryService.bisTrackSettings.paymentProvider == BisTrackSettingsPaymentProvider.Epicor) {
      this.quickOrderService.wizardView = false;
      this.quickOrderSummaryService.cardVerificationFlag = false;
      localStorage.setItem('HostedTokenUrl', this.quickOrderSummaryService.bisTrackSettings.creSettings.hostedTokenUrl + '/hp/hostedpayments.js');
      localStorage.setItem('TokenNamespace', this.quickOrderSummaryService.bisTrackSettings.creSettings.tokenNamespace);
      this.quickOrderSummaryService.setViewsVisible(false, false, false, false, false, false, true);
      this.quickOrderSummaryService.waitFlag = true;
      this.loadPaymentView();
    }
  }

  emailLinkClick() {
    this.loadEmailViewData();
  }

  buttonClick(buttonName: string) {
    switch (buttonName) {
      case 'Complete':
        this.completeQuickOrder();
        break;
      case 'Email':
        this.emailLinkClick();
        break;
      case 'PayNow':
        this.payNowClick('PayNow');
        break;
      case 'PayLater':
        this.completeQuickOrder();
        break;
      case 'EmailLink':
        this.epbtFaQuickOrderEmailComponent.onSendEmail();
        break;
      case 'TryAgain':
        if (!this.isQuickOrder) {
          this.quickOrderSummaryService.setViewsVisible(true, false, false, false, false, false, false);
        }
        break;
      case 'Continue':
         this.payNowClick('Continue');
        break;
      case 'Return':
        // if (!this.quickOrderService.isNewOrder)
        this.return();
        // else
        //   this.quickOrderService.completeOrderFlag = false;
        break;
      case 'ReturnToQuickOrder':
        this.quickOrderService.completeOrderFlag = false;
        break;
      default:
        break;
    }
  }

  continueToi4GoV2iFrameClick() {

  }

  loadEmailViewData() {
    const dialog = EpDialogService.progress({ message: 'Loading E-mail view...', description: '' });
    this.quickOrderSummaryService.getEmailTemplate((emailTemplate: EmailTemplate) => {
      dialog.close();
      this.quickOrderSummaryService.setViewsVisible(false, true, false, false, false, false, false);
      this.quickOrderSummaryService.emailTemplate = emailTemplate;
    });
  }

  loadSummary() {
    if (this.quickOrderService.quickOrder) {
      const transactionType = this.quickOrderService.quickOrder.TransactionType == 2 ? CheckoutParametersTransactionType.Quote : CheckoutParametersTransactionType.Order;
      if (transactionType == CheckoutParametersTransactionType.Order && this.quickOrderService.quickOrder.customer.cashAccount) {
        this.quickOrderService.emailButton = true;
      } else {
        this.quickOrderService.emailButton = false;
      }

      this.i4Go1 = this.quickOrderService.i4GoVersion == '1';
      this.i4Go2 = this.quickOrderService.i4GoVersion == '2';

      if (this.quickOrderService.i4GoVersion == '2') {
        this.quickOrderService.useAVS = true;
        this.quickOrderService.cardHolderNameDiv = this.quickOrderService.bisTrackSettings.shift4Settings.i4GoCardholderNamePrompt != Shift4SettingsI4GoCardholderNamePrompt.NotDisplayed;
        this.quickOrderService.streetAddressDiv = this.quickOrderService.bisTrackSettings.shift4Settings.i4GoStreetAddressPrompt != Shift4SettingsI4GoStreetAddressPrompt.NotDisplayed;
        this.quickOrderService.postalCodeDiv = this.quickOrderService.bisTrackSettings.shift4Settings.i4GoPostalCodePrompt != Shift4SettingsI4GoPostalCodePrompt.NotDisplayed;
      }

      if (this.quickOrderService.quickOrder.i4GoError) {
        this.i4GoErrorCodeLiteralText = this.quickOrderService.quickOrder.i4GoError;
        this.quickOrderService.quickOrder.i4GoError = '';
        this.i4GoErrorView = true;
        return;
      }

      this.quickOrderService.quickOrder.AttemptedQuickOrderPayment = false;
      this.quickOrderSummaryService.clearSessionPaymentParameters();
      this.quickOrderSummaryService.setViewsVisible(true, false, false, false, false, false, false);
      this.quickOrderService.paymentAmountField = this.quickOrderService.allowCardEntry;
      this.setButtonsVisiblility();
    }
  }

  setButtonsVisiblility() {
    this.quickOrderService.submitButton = true;
    this.quickOrderService.payNowButton = false;
    if (this.quickOrderService.quickOrder.customer && this.quickOrderService.quickOrder.branch) {
      if (this.quickOrderService.quickOrder.Lines.length > 0) {
        const transactionType = this.quickOrderService.quickOrder.TransactionType == 2 ? CheckoutParametersTransactionType.Quote : CheckoutParametersTransactionType.Order;
        this.quickOrderService.payNowButton = this.quickOrderService.allowCardEntry;

        if (this.quickOrderService.allowCardEntry && transactionType != CheckoutParametersTransactionType.Quote) {
          this.quickOrderService.submutButtonLabel = 'Pay Later';
        } else {
          this.quickOrderService.submutButtonLabel = 'Complete';
          this.quickOrderService.payNowButton = false;
        }

        let saleType;
        if (this.quickOrderService.quickOrder.selectedSalesType == 1) {
          saleType = CheckoutParametersSaleType.CollectNow;
        } else if (this.quickOrderService.quickOrder.selectedSalesType == 2) {
          saleType = CheckoutParametersSaleType.CollectLater;
 } else if (this.quickOrderService.quickOrder.selectedSalesType == 3) {
          saleType = CheckoutParametersSaleType.Delivered;
 }

        // 169600: If Cash sale and Sale Type of "Pickup Now", then only option is to pay now
        if (this.quickOrderService.quickOrder.customer.cashAccount && saleType == CheckoutParametersSaleType.CollectNow) {
          // 169600 QC#3 Show Complete button for quotes , hide it otherwise
          this.quickOrderService.submitButton = transactionType == CheckoutParametersTransactionType.Quote;
          this.quickOrderService.emailButton = false;
        } else {
        }
      }
    }
  }

  loadPaymentView() {
    this.quickOrderSummaryService.waitFlag = true;
    if (this.isQuickOrder) {
      localStorage.setItem('QuickOrder', 'In-Progress');
      localStorage.setItem('PaymentType', 'QuickOrder');
    } else {
      localStorage.setItem('Order', 'In-Progress');
      localStorage.setItem('PaymentType', 'Order');
    }
  }

  return() {
    if (this.isQuickOrder) {
      this.quickOrderService.wizardView = true;
    }
    this.quickOrderSummaryService.setViewsVisible(true, false, false, false, false, false, false);
  }

  cancelQuickOrderClick() {
    if (!this.isQuickOrder) {
      this.router.navigate(['/home/customer/details', this.quickOrderService.quickOrder.customer.customerId]);
    } else {
      this.router.navigate(['/home']);
    }

    this.quickOrderService.clearData();
  }
}
